import instanceQuery from 'graphql/queries/customer/CustomerGlobalAmendQuery.graphql';
import defaultQuery from 'graphql/queries/customer/CustomerGlobalAmendDefault.graphql';
import mutationQuery from 'graphql/mutations/customer/CustomerGlobalAmendMutation.graphql';
import fragment from 'graphql/fragments/customer/CustomerGlobalAmendFragment.graphql';

const CustomerGlobalAmend = {
  type: 'CustomerGlobalAmend',
  title: 'Customer Global Amendments',
  formTitle: 'Customer Global Amendments',
  formUrl: '/Customers/GlobalAmendments/',
  default: defaultQuery,
  instance: instanceQuery,
  update: mutationQuery,
  fragment,
  screenReference: 'CUSTOMERS_GLOBAL_AMENDMENTS',
  resultUrl: '/Customers/CustomerGlobalAmendResultDetails/Workspace/',
};

export default CustomerGlobalAmend;
